/* eslint-disable no-console */
<template>
<div>
    <div class="card z-depth-5 p-3">
        <h4 class="text-center font-weight-bold py-3">All Payments</h4>
        <div class="table-responsive">
            <table class="table table-bordered">
                <thead class="thead-dark">
                    <tr>
                        <th scope="col">First Name</th>
                        <th scope="col">Last Name</th>
                        <th scope="col">Age Bracket</th>
                        <th scope="col">Payment Plan</th>
                        <th scope="col">Payment Date</th>
                        <th scope="col">Expiry Date</th>
                        <th scope="col">Payment Status</th>
                        <th scope="col">Payer Name</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="payment in payments" :key="payment._id">
                        <th>{{payment.user.first_name}}</th>
                        <td>{{payment.user.last_name}}</td>
                        <td>{{payment.user.age_bracket}}</td>
                        <td>{{payment.plan_id}}</td>
                        <td>{{convertTime(payment.date)}}</td>
                        <td>{{convertTime(payment.expiration)}}</td>
                        <td>{{payment.data.status}}</td>
                        <td>{{payment.data.payer.name.given_name}} {{payment.data.payer.name.surname}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>
</template>

<script>
import axios from "axios"
export default {
    name: 'Plans',
    components: {

    },
    data() {
        return {
            payments: [],
            fastAdminToken : localStorage.getItem("fastAdminToken")
            // page: this.$route.params.page
        }
    },
    methods: {
        convertTime(timestamp) {
            let d = new Date(timestamp);
            return d.getDate() + '/' + (d.getMonth() + 1) + '/' + d.getFullYear()
        }
    },
    mounted() {

        this.$toast.open({
            message: "Processing : Loading Subscriptions Please Wait...",
            type: 'info'
        })

        const config = {
            headers: {
                Authorization: "Bearer " + this.fastAdminToken,
                'Content-Type': 'application/json'
            }
        }
        axios.get(this.$apiURI + "/subscription/all", config)
            .then((response) => {
                if (response.data.error) {
                    this.$toast.open({
                        message: "Error : " + response.data.message,
                        type: 'error'
                    });
                } else {
                    
                    // eslint-disable-next-line no-console
                    // console.log(response.data.data.teachers)
                    this.payments = response.data.data.subscriptions
                }

            }).catch((error) => {
                this.$toast.open({
                    message: "Error : " + error.response.data.message,
                    type: 'error'
                });
            })
    }
}
</script>
